import demandForm from '@/view/need/form'
import success from '@/view/need/success'

const needRouter = [
  {
    path: '/need/add.html',
    name: 'need-demand-form',
    component: demandForm,
    meta: {
      title: '提交需求'
    }
  },
  {
    path: '/need/success.html',
    name: 'need-success',
    component: success,
    meta: {
      title: '河姆渡方案馆'
    }
  }
]

export default needRouter



// WEBPACK FOOTER //
// ./src/router/need/need.js